import React, {useEffect, useState} from 'react';
import Table from "components/table/table";
import EmptyState from "components/EmptyState/EmptyState";
import ApiDatabase from "server";
import MediaQuery from "react-responsive";
import Cardcontract from "components/card/cardcontract";
import Button from "components/button";
import UseContext from "hooks/useContext";
import useTitle from "../../../../hooks/TitleManager";
import { formatChangeValue, getFieldLabel } from "utils/amendmentFormat";


const Nosign = () => {
    useTitle({ title: "Contrats à signer" });
    const {refreshContract, setAmendmentRequestData, setAmendmentAction, setModalType, setModalShow}=UseContext()
    const champsHeader=['N° de contrat','Entreprise','MISSION','N° De mission','ÉTAT','DATE']
    const [arrayContracts, setArrayContracts] = useState([])
    const [amendmentRequests, setAmendmentRequests] = useState([])
    const [isWaiting, setIsWaiting] = useState(true);

    useEffect(() => {
        const idU = localStorage.getItem('xsrfToken')
        ApiDatabase.getContracts({id: idU, pStatus: '0', includePending: true},
            (data) => {
                setArrayContracts(data)
                setIsWaiting(false)
            },
            (err) => {
                console.log(err)
            })
    }, [refreshContract])

    useEffect(() => {
        ApiDatabase.getAmendmentRequests({},
            (data) => setAmendmentRequests(data || []),
            () => setAmendmentRequests([])
        );
    }, [refreshContract])

    const openAmendmentModal = (request, action) => {
        setAmendmentRequestData(request);
        setAmendmentAction(action);
        setModalType('amendment_response');
        setModalShow(true);
    }

    return (
        <>
            {amendmentRequests.length > 0 && (
              <div className="flex flex-col gap-2 mb-4">
                <div className="ft-b text-gray-700">Demandes de prolongation en attente</div>
                {amendmentRequests.map((request) => (
                  <div key={request._id} className="border-2 border-yellow-300 rounded-md p-3 flex flex-col gap-2">
                    <div className="flex justify-between items-center">
                      <span className="ft-sm ft-b">
                        {request.idMission?.title || 'Mission'} - n°{request.idMission?.id_mission || ''}
                      </span>
                      <span className="text-xs text-gray-500">
                        {new Date(request.createdAt).toLocaleDateString('fr-FR')}
                      </span>
                    </div>
                    {request.changes?.map((c, i) => (
                      <div key={i} className="ft-sm text-gray-600 flex items-center gap-1 flex-wrap">
                        <span className="font-medium text-gray-700">{getFieldLabel(c.field)}</span>
                        <span className="line-through text-gray-400">
                          {formatChangeValue(c.field, c.before)}
                        </span>
                        <span className="text-gray-400">→</span>
                        <span>
                          {formatChangeValue(c.field, c.after)}
                        </span>
                      </div>
                    ))}
                    <div className="flex gap-2 mt-1">
                      <Button color="PRIMARY" size="SM" onClick={() => openAmendmentModal(request, 'accept')}>
                        Accepter
                      </Button>
                      <Button color="SECONDARY" size="SM" onClick={() => openAmendmentModal(request, 'refuse')}>
                        Refuser
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <MediaQuery minWidth={770}>
                {
                    isWaiting ? (
                        <>
                            {
                                [1, 2, 3, 4, 5].map((i, index) => (
                                    <Table champsBody={i} champsHeader={champsHeader} isWaiting={isWaiting}/>
                                ))
                            }
                        </>
                    ) : (
                        <>
                            {
                                arrayContracts.length ?
                                    <Table champsHeader={champsHeader} champsBody={arrayContracts} filterStatus="0"/>
                                    :
                                    <EmptyState type={'contract_nosign'}/>
                            }
                        </>
                    )
                }
            </MediaQuery>
            <MediaQuery maxWidth={769}>
                {
                    isWaiting ? (
                        <>
                            <div className={'animate-pulse w-full'}>
                                {
                                    [1, 2, 3, 4, 5].map((i, index) => (
                                        <Cardcontract item={i} isWaiting={isWaiting}/>
                                    ))
                                }
                            </div>
                        </>
                    ) : (
                        <>
                            {
                                arrayContracts.length ?
                                    arrayContracts?.map(item =>
                                        <Cardcontract champsBody={item} filterStatus="0"/>
                                    )
                                    :
                                    <EmptyState type={'contract_nosign'}/>
                            }
                        </>
                    )
                }
            </MediaQuery>
        </>
    );
};

export default Nosign;